import { TradingOffer } from 'types/TradingOffer';

import { isOfferActive } from './getOfferStatus';

export const filterActiveTradingOffers = (
  offers: TradingOffer[]
): TradingOffer[] => offers.filter(isOfferActive);

export default filterActiveTradingOffers;
